const reducer = {
  setFieldPipeline(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
};

export default reducer;
